(function() {
    'use strict';

    var ExpenseClaimItemCtrl = function ($scope, $uibModalInstance, ajaxCall) {

        // $controller('ModalCtrl', {$scope: $scope}); // ModalCtrl inheritance
        // is this missing / overwritten ?

        $scope.expenseItemModel = {};
        $scope.pageModel = {};
        $scope.hideSearch = false;


        $scope.expenseChange = function(){
            console.log('is this compiling????');
            var mileageVal = $scope.expenseItemModel.mileage;
            var expenseTypeId = $scope.expenseItemModel.expenseType;
            var costPerMile = angular.isDefined($scope.expenseItemModel.costPerMile)           ? $scope.expenseItemModel.costPerMile        : null;
            var ajaxUrl = WEBAPP_PATH + "/expenseClaim/additionalInformation";
            var data = {mileageVal: mileageVal, expenseTypeId:expenseTypeId, costPerMile: costPerMile};

            $scope.expenseItemModel.additionalInformation = "";

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.expenseItemModel.additionalInformation = result.data.additionalInformation;
                    $scope.expenseItemModel.costPerMile = result.data.costPerMile;
                    $scope.expenseItemModel.maxCostPerMile = result.data.maxCostPerMile;
                    $scope.expenseItemModel.costPerMileEditable = result.data.costPerMileEditable;
                    $scope.expenseItemModel.costOfExpense = parseFloat(result.data.mileageCostString, 10);

                }, function(jqXHR, textStatus, errorThrown) {
                    console.log ("error reading info type")
                }
            );
        }

        $scope.incrementAttachmentCount = function(count) {
            if($scope.expenseItemModel.attachmentcount==undefined){
               $scope.expenseItemModel.attachmentcount = 1;
            }else{
               $scope.expenseItemModel.attachmentcount = $scope.expenseItemModel.attachmentcount+1;
            }
        }

        $scope.decrementAttachmentCount = function(count) {
            if($scope.expenseItemModel.attachmentcount==undefined||$scope.expenseItemModel.attachmentcount == 0){
                $scope.expenseItemModel.attachmentcount = 0;
             }else{
                $scope.expenseItemModel.attachmentcount = $scope.expenseItemModel.attachmentcount-1;
             }

        }

        $scope.mileagechange = function() {
            var mileageVal = $scope.expenseItemModel.mileage;
            var expenseTypeId = $scope.expenseItemModel.expenseType;
            var costPerMile = angular.isDefined($scope.expenseItemModel.costPerMile)           ? $scope.expenseItemModel.costPerMile        : null;
            var ajaxUrl = WEBAPP_PATH + "/expenseClaim/mileageCost";
            var data = {mileageVal: mileageVal, expenseTypeId:expenseTypeId, costPerMile: costPerMile};

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.expenseItemModel.costOfExpense = parseFloat(result.data.mileageCostString, 10);
                }, function(jqXHR, textStatus, errorThrown){}
            );
        }


        $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }
        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.hideSearch = function() {
            return false;
        }

    }

    ExpenseClaimItemCtrl.$inject = ['$scope','$uibModalInstance', 'ajaxCall'];
    angular.module('app').controller('ExpenseClaimItemCtrl',ExpenseClaimItemCtrl);

    angular.module('app').filter('addOneDay', [function() {
        return function(fromDate) {
            var date = null;
            if(fromDate != undefined){
                date = new Date();
                date = new Date(fromDate);
                date.setDate(date.getDate() + 1);
            }
            return date;
        };
    }]);

}());

